import { Dropdown, FormField, listItemSelectBuilder } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { RuleFooter } from '@wix/rules-panel-ui';
import { useSetAtom } from 'jotai';
import React, { useMemo, useState } from 'react';
import { unsavedChangedHandlersAtom } from '../../../../../atoms/session-atoms';
import { BiCtaNames, BiFieldNames } from '../../../../../bi/types';
import { useBiLogger } from '../../../../../hooks/use-bi-logger';
import { useResetUnsavedChangesHandlers } from '../../../../../hooks/use-reset-unsaved-changes-handlers';
import { dataHooks } from '../../../../../utils/datahooks';
import { getHeadingDropdownOption } from '../../utils/heading-dropdown-option';
export const HeadingStructureRuleRegularContent = _ref => {
  let {
    onClickCancel,
    onClickApply,
    headingDefinition,
    failedReason,
    showLoader,
    dataHook,
    index,
    status
  } = _ref;
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const dropdownOptions = useMemo(() => getHeadingDropdownOption(t), [t]);
  const [value, setValue] = useState(headingDefinition.toLowerCase());
  const setUnsavedChangedHandlers = useSetAtom(unsavedChangedHandlersAtom);
  const {
    resetUnsavedChangesHandlers
  } = useResetUnsavedChangesHandlers();
  const optionsForRender = dropdownOptions.map(_ref2 => {
    let {
      id,
      value: title
    } = _ref2;
    return listItemSelectBuilder({
      id,
      label: title,
      size: 'small',
      title
    });
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormField, {
    dataHook: dataHooks.headingStructureRuleContentFormField(dataHook),
    label: t('accessibility-wizard.rules-list.heading-definition.dropdown-field.label'),
    labelSize: "tiny",
    status: failedReason ? 'error' : undefined,
    statusMessage: failedReason ? t(`accessibility-wizard.rules-list.heading-definition.errors.${failedReason}`) : undefined
  }, /*#__PURE__*/React.createElement(Dropdown, {
    dataHook: dataHooks.headingStructureRuleContentDropdown(dataHook),
    disabled: showLoader,
    options: optionsForRender,
    selectedId: value,
    size: "small",
    valueParser: option => option.label,
    onOptionsShow: () => biLogger.taskElementCtaClick({
      ctaName: BiCtaNames.DropdownClick,
      index,
      status
    }),
    onSelect: option => {
      setValue(option.id);
      biLogger.elementFieldChange({
        fieldName: BiFieldNames.HeadingTag,
        index,
        status,
        value: option.id
      });
      if (option.id !== headingDefinition) {
        setUnsavedChangedHandlers({
          apply: async () => {
            onClickApply(option.id);
            setUnsavedChangedHandlers({
              apply: async () => {},
              exists: false
            });
          },
          exists: true
        });
      } else {
        resetUnsavedChangesHandlers();
      }
    }
  })), /*#__PURE__*/React.createElement(RuleFooter, {
    dataHook: dataHooks.headingStructureRuleContentRuleFooter(dataHook),
    dismissButtonProps: {
      label: t('accessibility-wizard.rules-list.heading-definition.dropdown-field.footer-button.cancel'),
      onClick: () => {
        onClickCancel();
        resetUnsavedChangesHandlers();
      }
    },
    submitButtonProps: {
      disabled: value === headingDefinition.toLowerCase(),
      label: t('accessibility-wizard.rules-list.heading-definition.dropdown-field.footer-button.apply'),
      onClick: () => {
        onClickApply(value);
        resetUnsavedChangesHandlers();
      },
      showLoader
    }
  }));
};
//# sourceMappingURL=heading-structure-rule-regular-content.js.map